import React, { useEffect, useState } from "react";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import ChannelForm from "../component/ChannelForm";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ChannelInsituteForm from "../../ChannelPartnerInstitute/component/ChannelInstituteForm";

const ChannelPartner = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  const toggleAssignModal = (item) => {
    setSelectedItem(item);
    setIsAssignModalOpen(!isAssignModalOpen);
  };
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await ChannelService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await ChannelService.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Channel Partners" pageTitle="KEF Intelligence" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button className="btn btn-success" onClick={toggleModal}>
              <i className="bi bi-plus-lg"></i> New Partner
            </button>
          </div>{" "}
        </Row>

        <Row  className="">
          {data?.map((item, index) => {
            return (
              <Col lg={6} key={item.id}>
                <Card>
                  <div style={{ height: "200px", overflow: "hidden" }}>
                    <CardImg
                      top
                      src={`${imageBaseApi}${item?.logo?.url}`}
                      alt={item.fileName}
                      style={{
                        objectFit: "contain",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                  <CardBody>
                    <p>{item?.name}</p>

                    <div className="d-flex align-items-center gap-2 flex-wrap">
                      {item?.universities?.slice(0, 7).map((uni, index) => (
                        <img
                          key={index}
                          src={`${imageBaseApi}${uni?.logo?.url}`}
                          className="avatar-sm object-fit-contain"
                          alt="university-logo"
                        />
                      ))}

                      {item?.universities?.length > 7 && (
                        <div
                          className="avatar-sm d-flex align-items-center justify-content-center bg-light text-primary fw-semibold cursor-pointer"
                          onClick={() =>
                            navigate(`/channel-partner/${item.id}`)
                          }
                        >
                          +{item.universities.length - 8}
                        </div>
                      )}
                    </div>
                  </CardBody>
                  <CardFooter>
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => toggleModal(item)}
                      >
                        <i className="ri-edit-line"></i>
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        className="d-flex align-items-center gap-1"
                        onClick={() => handleDeleteClick(item)}
                      >
                        <i className="ri-delete-bin-5-line"></i>
                      </Button>

                      <Button
                        size="sm"
                        color="warning"
                        className="d-flex align-items-center gap-1"
                        onClick={() => toggleAssignModal(item)}
                      >
                        Assign institute
                      </Button>
                    </div>
                  </CardFooter>
                </Card>
              </Col>
            );
          })}
        </Row>

        <ChannelForm
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <ChannelInsituteForm
          isOpen={isAssignModalOpen}
          toggle={toggleAssignModal}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />

        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default ChannelPartner;
